/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract MiniMeStorageOracle",
                name: "_storageOracle",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
        ],
        name: "PollConfigured",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "proofData",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "storageOracle",
        outputs: [
            {
                internalType: "contract MiniMeStorageOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MiniMeStorageACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_storageOracle, overrides) {
        return super.getDeployTransaction(_storageOracle, overrides || {});
    }
    deploy(_storageOracle, overrides) {
        return super.deploy(_storageOracle, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MiniMeStorageACL__factory.bytecode = _bytecode;
MiniMeStorageACL__factory.abi = _abi;
//# sourceMappingURL=MiniMeStorageACL__factory.js.map